import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { Modal, ModalProps, SpinningLoader } from '@frontend/design-system';

export const TemplateSelectorModal = ({ children, isLoading, ...rest }: ModalProps & { isLoading?: boolean }) => {
  const isLargeMode = useMatchMedia({ minWidth: breakpoints.xsmall.max });
  return (
    <Modal.Responsive
      minWidth={680}
      css={[
        { display: 'flex', flexDirection: 'column', overflow: 'hidden' },
        isLargeMode && { height: '495px' },
        isLoading && { justifyContent: 'center', alignItems: 'center' },
      ]}
      {...rest}
    >
      {isLoading ? <SpinningLoader /> : children}
    </Modal.Responsive>
  );
};
